import React, { useState, useEffect } from 'react'
import { css } from 'emotion'
import EirButton from '../eir-button/EirButton'
import { Container } from 'reactstrap';

import { TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';
import styled from '@emotion/styled'
import { isMobileOnly } from 'react-device-detect';
import { LargeBusiness, htmlWidget } from '../../Constants';

const EirTabTiles = (props) => {


    const renderContent = (content) => {
        return { __html: content };
    }
    const isLBSite = (LargeBusiness.isLBSite);
    const [tabCTA1] = React.useState(props.tab.CTA1);
    const [tabCTA2] = React.useState(props.tab.CTA2);
    const [tabstylingCTA1] = React.useState({
        backgroundColor: props.tab.CTA1Color,
        color: props.tab.CTA1FontColor,
        borderColor: props.tab.CTA1OutlineColor,
        hover: {
            backgroundColor: props.tab.CTA1HoverColor,
            color: props.tab.CTA1FontColorHover,
            borderColor: props.tab.CTA1HoverColor,
        }
    })
    const [tabstylingCTA2] = React.useState({
        backgroundColor: props.tab.CTA2Color + " !important",
        color: props.tab.CTA2FontColor,
        borderColor: props.tab.CTA2OutlineColor,
        hover: {
            backgroundColor: props.tab.CTA2HoverColor,
            color: props.tab.CTA2FontColorHover,
            borderColor: props.tab.CTA2HoverColor,
        }
    })

    let tabCTA1props = (tabCTA1 != undefined ? ({
        text: tabCTA1.text,
        title: tabCTA1.title,
        link: tabCTA1.link,
        target: tabCTA1.target,
        type: tabCTA1.type,
        icon: tabCTA1.icon,
        buttonStyle: tabCTA1.buttonStyle,
        buttonSize: tabCTA1.buttonSize,
        theme: tabCTA1.theme,
        videoModal: tabCTA1.VideoModal,
        styling: tabstylingCTA1

    }) : {});

    let tabCTA2props = (tabCTA2 != undefined ? ({
        text: tabCTA2.text,
        title: tabCTA2.title,
        link: tabCTA2.link,
        target: tabCTA2.target,
        type: tabCTA2.type,
        icon: tabCTA2.icon,
        buttonStyle: tabCTA2.buttonStyle,
        buttonSize: tabCTA2.buttonSize,
        theme: tabCTA2.theme,
        videoModal: tabCTA2.VideoModal,
        styling: tabstylingCTA2

    }) : {});

    return (
        <div>
            <Row className={((isMobileOnly) ? "p-4 lb-tab-row-padding" : "pt-5 pl-5 pr-5 pb-3 lb-tab-row-padding")}>
                {(!props.Image2 && !props.Text2) ?
                    <Col sm="12" className={isLBSite ? "d-flex align-items-center" : "d-flex justify-content-center align-items-center"}>
                        {props.Image1 &&
                            <img className={isLBSite ? "w-100 lb-tab-content-image" : "w-100 mb-2"} src={props.Image1.path} alt={props.Alt1} />}
                        {props.Text1 && <div className={htmlWidget + ' lb-tab-content'} dangerouslySetInnerHTML={renderContent(props.Text1)} ></div>
                        }
                    </Col> :
                    <Col sm="6" className={isLBSite ? "d-flex justify-content-center" : "d-flex justify-content-center align-items-center"}>
                        {props.Image1 &&
                            <img className={isLBSite ? "w-100 lb-tab-content-image" : "w-100 mb-2"} src={props.Image1.path} alt={props.Alt1} />}
                        {props.Text1 && <div className={htmlWidget + ' lb-tab-content'} dangerouslySetInnerHTML={renderContent(props.Text1)} ></div>
                        }
                    </Col>
                }
                {(!props.Image1 && !props.Text1) ?
                    <Col sm="12" className={isLBSite ? "d-flex align-items-center" : "d-flex justify-content-center align-items-center"}>
                        {props.Image2 &&
                            <img className={isLBSite ? "w-100 lb-tab-content-image" : "w-100 mb-2"} src={props.Image2.path} alt={props.Alt2} />}
                        {props.Text2 && <div className={htmlWidget + ' lb-tab-content'} dangerouslySetInnerHTML={renderContent(props.Text2)} ></div>
                        }
                    </Col> :
                    <Col sm="6" className={isLBSite ? "d-flex justify-content-center" : "d-flex justify-content-center align-items-center"}>
                        {props.Image2 &&
                            <img className={isLBSite ? "w-100 lb-tab-content-image" : "w-100 mb-2"} src={props.Image2.path} alt={props.Alt2} />}
                        {props.Text2 && <div className={htmlWidget + ' lb-tab-content'} dangerouslySetInnerHTML={renderContent(props.Text2)} ></div>}

                    </Col>
                }
            </Row>
            {(!isMobileOnly) &&
                <div>
                    {props.tab.CTA1 &&
                        <div className={('ml-5 mr-5 cta ') + (((props.tab.AlignmentCTA1 == 'centre') && (props.tab.AlignmentCTA2 == 'centre')) ? 'd-flex justify-content-center align-items-center' : (((props.tab.AlignmentCTA1 == 'right') && (props.tab.AlignmentCTA2 == 'right')) ? 'd-inline-flex float-right ml100' : ''))}>
                            <div className={(props.tab.AlignmentCTA1 == 'centre') ? 'd-flex justify-content-center align-items-center lb-tab-margin-padding' : (props.tab.AlignmentCTA1 == 'left') ? 'float-left lb-tab-margin-padding' : 'float-right lb-tab-margin-padding .lb-tab-margin-padding-right'}>
                                <EirButton  {...tabCTA1props} databundlecode={props.tab.id}
                                    outline={true}
                                    className={isMobileOnly ? '' : 'mr-3 ' + "mb-3 js-prequal-modal-btn cta_threesix ls-0 " + tabCTA1props.type == 'button' ? "eir-text-secondary p-2 " : "link_threesix "}
                                />
                            </div>
                            {props.tab.CTA2 &&
                                <div className={(props.tab.AlignmentCTA2 == 'centre') ? 'd-flex justify-content-center align-items-center lb-tab-margin-padding' : (props.tab.AlignmentCTA2 == 'left') ? 'float-left lb-tab-margin-padding' : 'float-right lb-tab-margin-padding lb-tab-margin-padding-right'}>
                                    <EirButton  {...tabCTA2props} databundlecode={props.tab.id}
                                        outline={true}
                                        className={"mb-3 js-prequal-modal-btn cta_threesix ls-0 " + tabCTA2props.type == 'button' ? "eir-text-secondary p-2 " : "link_threesix "}
                                    />
                                </div>
                            }
                        </div>
                    }
                </div>
            }
            {(isMobileOnly) &&
                <div className="position-relative display-grid">

                    {props.tab.CTA1 &&
                        <div className={(props.tab.AlignmentCTA1 == 'centre') ? 'd-flex justify-content-center align-items-center lb-tab-margin-padding' : (props.tab.AlignmentCTA1 == 'left') ? 'float-left ml-4 lb-tab-margin-padding' : 'float-right ml-auto mr-4 lb-tab-margin-padding'}>
                            <EirButton  {...tabCTA1props} databundlecode={props.tab.id}
                                outline={true}
                                className={((isMobileOnly) ? '' : 'mr-3 ') + "mb-3 js-prequal-modal-btn cta_threesix ls-0 " + tabCTA1props.type == 'button' ? "eir-text-secondary p-2 " : "link_threesix "}
                            />
                        </div>

                    }

                    {props.tab.CTA2 &&
                        <div className={(props.tab.AlignmentCTA2 == 'centre') ? 'd-flex justify-content-center align-items-center lb-tab-margin-padding' : (props.tab.AlignmentCTA2 == 'left') ? 'float-left ml-4 lb-tab-margin-padding' : 'float-right ml-auto mr-4 lb-tab-margin-padding'}>
                            <EirButton  {...tabCTA2props} databundlecode={props.tab.id}
                                outline={true}
                                className={"mb-3 js-prequal-modal-btn cta_threesix ls-0 " + tabCTA2props.type == 'button' ? "eir-text-secondary p-2 " : "link_threesix "}
                            />
                        </div>
                    }

                </div>
            }
            {props.BottomImage &&
                <div className="bottomImage">
                    <img className="image w-100" src={props.BottomImage.path} />
                </div>
            }
        </div>
    )
}


export default EirTabTiles
